import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {NotFountComponent} from './common/abnormal/not-fount/not-fount.component';

const routes: Routes = [
    {path: '', loadChildren: 'src/app/home/home.module#HomeModule'},
    {path: 'auth', loadChildren: 'src/app/auth/auth.module#AuthModule'},
    {path: 'console', loadChildren: 'src/app/console/console.module#ConsoleModule'},
    {path: '**', component: NotFountComponent, data: {title: 'HOT-FOUNT'}},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
